import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Text, useThemeName } from '@tamagui/core';
import { XStack, YStack } from '@tamagui/stacks';
import { X } from 'lucide-react-native';
import { COLORS } from '@/constants/colors';

type ScreenHeaderProps = {
  title: string;
  onBackPress?: () => void;
  rightButton?: React.ReactNode;
};

/**
 * Shared header component for web screens
 * Used in CreateAnnouncementScreen, MyProfileScreen, etc.
 */
export const ScreenHeader: React.FC<ScreenHeaderProps> = ({ title, onBackPress, rightButton }) => {
  const themeName = useThemeName();
  const isDark = themeName === 'dark';
  
  const cardBg = isDark ? '#1a1a1a' : COLORS.WHITE;
  const textColor = isDark ? '#ffffff' : '#18181b';
  const borderColor = isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)';

  return (
    <XStack
      paddingHorizontal="$4"
      paddingVertical="$3"
      alignItems="center"
      justifyContent="space-between"
      backgroundColor={cardBg}
      borderBottomWidth={1}
      borderBottomColor={borderColor}
    >
      <TouchableOpacity onPress={onBackPress || (() => {})}>
        <X size={24} color={textColor} />
      </TouchableOpacity>
      <Text fontSize="$5" fontWeight="700" color={textColor}>
        {title}
      </Text>
      {rightButton || <YStack width={24} />}
    </XStack>
  );
};

export default ScreenHeader;



